'use strict';

/*
--- 
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.4.1: '*'
...
*/
var ComparisonTable = new Class({
	Implements: Options,
	options: {
		cls: 'w_scrollable',
		empty_msg: '', //'Add building to compare',
		nodata_msg: 'There is not enough data for this building',
		alreadythere_msg: ' is already added to comparison table'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._message = new Element('div', { 'class': 'message', 'html': this.options.empty_msg + '<div class="close">x</div>' });

		this._message.addEvent('click', function () {
			this.hide_message();
		}.bind(this));
		//this._element.addClass('empty');

		this._message.inject(this._element.getParent('.comparison_table'), 'before').hide();

		this._scroller = this._element.getElement('.scroller') ? this._element.getElement('.scroller') : new Element('div', { 'class': 'scroller clearfix' }).inject(this._element, 'top');

		this.tables = 0;
		this.main_width = this._element.getSize().x;
		this.scroller_width = 0;
		this.scrolling_times = 0;

		this.bld_titles = [];

		this._parent = this._element.getParent();
		// this._bulb = new Element('div', {
		//																	 'class': this.options.cls + '_bulb',
		//																	 'html': '<div class="pointer">&nbsp;</div>' +
		//																					 '<div class="bulb_content clearfix"></div>'
		//																 }).inject(this._parent);

		// this._bulb_content = this._bulb.getElement('.bulb_content');


		var _peer_buildings = this._scroller.getElements('.w_divtable');
		if (_peer_buildings) {
			this._scroller.empty();
			_peer_buildings.each(function (_el) {
				this.insert_content(_el.get('html'), _el.get('data-rpc'), null);
			}.bind(this));
		}
	},

	rpc_request: function rpc_request(url) {
		this.remote = new Remote({
			rpc: url,
			onSuccess: this.process_rpc.bind(this)
		});
	},

	process_rpc: function process_rpc() {
		var data = this.remote.get_data(),
		    content = data.content,
		    url = data.url,
		    warning = data.warning;

		this.insert_content(content, url, warning);
	},

	insert_content: function insert_content(content, url, warning) {
		if (content && content != '') {
			this._element.removeClass('empty');
			this.hide_message();

			var _table = new Element('div', { 'class': 'w_divtable', 'html': content }),
			    _title = _table.getElement('.th .name'),
			    title = _title.get('text');

			var btn_height = _table.getElement('div').getSize().y - _table.getElement('div .tr').getSize().y;

			if (btn_height > 0) {
				this._element.getElement('.scroll_left').setStyle('height', btn_height);
				this._element.getElement('.scroll_right').setStyle('height', btn_height);
			}

			if (this.bld_titles.contains(title)) {
				this.show_warning(title + this.options.alreadythere_msg);
			} else {
				this.bld_titles.push(title);

				var _close = _table.getElement('.close') || new Element('div', { 'class': 'close', 'html': 'x' }).inject(_table);

				// _table.addEvents({
				//									 'mouseover': function() { if(!this.over_close){
				//																							 this.bulb_show(title, _table);
				//																						 }
				//																					 }.bind(this),
				//									 'mouseleave': function(){ 
				//																						 this.bulb_hide();
				//																						 _table.removeClass('mouseover');
				//																					 }.bind(this)
				//								 });

				if (url && url != '') {
					_table.setAttribute('data-class', 'w_blimp_bld');
					_table.setAttribute('href', url);

					this.blimp = new BlimpExt(_table, {
						draggable: true,
						show_veil: true,
						onPostRpc: function onPostRpc() {
							new BldBlimp(this);
						}
					});

					var blimp_veil = document.getElement('.w_popup_veil');

					if (blimp_veil) {
						var b_scroll = document.id(document.body).getScrollSize();
						blimp_veil.setStyle('height', b_scroll.y);
					}

					// _table.addEvent ('click', function(e){
					//	 if(this.over_close){
					//		 e.stop();
					//	 }
					// }.bind(this));

					_table.addClass('has_url');
				}

				_close.addEvents({
					'click': function (e) {
						if (e && e.stop) e.stop();

						this.dispose_table(_table);
					}.bind(this),
					'mouseover': function () {
						//this.over_close = true;
						this.blimp.active = false;
						// _table.toggleClass('mouseover');

						// if(url && url != '')
						//	 _table.toggleClass('has_url');

						// _table.fireEvent('mouseleave');
					}.bind(this),
					'mouseleave': function () {
						//this.over_close = false;
						this.blimp.active = true;
						// _table.toggleClass('mouseover');

						// if(url && url != '')
						//	 _table.toggleClass('has_url');												
					}.bind(this)
				});

				_table.inject(this._scroller, 'top');

				var btn_height = _table.getElement('div').getSize().y - _table.getElement('div .tr').getSize().y;

				if (btn_height > 0) {
					this._element.getElement('.scroll_left').setStyle('height', btn_height - 4 /*gap*/);
					this._element.getElement('.scroll_right').setStyle('height', btn_height - 4 /*gap*/);
				}

				if (!this.scrolling_width) {
					this.scrolling_width = _table.getSize().x + _table.getStyle('margin-right').toInt() + _table.getStyle('margin-left').toInt();
					_table.addClass('last');
				}

				this.tables++;

				if (this.tables == 1) {
					this.scroller_width += _table.getSize().x;
				} else {
					this.scroller_width += _table.getSize().x + _table.getStyle('margin-right').toInt();
				}

				if (this.scroller_width > this.main_width) {
					this.scrolling_times++;
				}

				this.resize_scroller();
				this.scroll_to('add');
			}

			var _last_table = this._element.getElement('.w_divtable.last');

			if (_last_table) {
				_last_table.removeClass('last');
			}

			_last_table = this._element.getElement('.w_divtable:last-child');

			if (_last_table) {
				_last_table.addClass('last');
			}
		} else if (warning && warning != '') {
			this.show_warning(warning);
		} else {
			this.show_warning(this.options.nodata_msg);
		}
	},

	show_warning: function show_warning(text) {
		// this._message.fade('hide');
		this._message.addClass('warning');
		var _close = this._message.getElement('.close').dispose();
		this._message.set('text', text);
		this._message.adopt(_close);
		// this._message.fade('in');

		// if(this.fadeout)
		//	 clearTimeout(this.fadeout);

		// this.fadeout = setTimeout(function(){ this._message.fade('out') }.bind(this), 4000);

		// (function() {
		//							 if(this._element.hasClass('empty')){
		//								 this._message.removeClass('warning');
		//								 this._message.set('text', this.options.empty_msg);
		//								 this._message.fade('in');
		//							 }
		//						 }.bind(this)).delay(4500);

		this._message.show();
	},

	hide_message: function hide_message() {
		this._message.hide();
	},

	dispose_table: function dispose_table(_table) {
		this.scroller_width -= _table.getSize().x - _table.getStyle('margin-right').toInt() - _table.getStyle('margin-left').toInt();
		_table.dispose();

		// if(!this._element.getElement('.w_divtable')){
		//	 this._element.addClass('empty');

		//	 this._message.removeClass('warning');
		//	 this._message.set('text', this.options.empty_msg);
		//	 this._message.fade('in');
		// }

		this.tables--;

		if (this.scrolling_times > 0) {
			this.scrolling_times--;
		}

		this.resize_scroller();
		this.scroll_to('remove');

		var title = _table.getElement('.th .name').get('text');
		this.bld_titles.erase(title);

		// this.bulb_hide();
		//this.over_close = false;
		_table.removeClass('has_url');

		var _last_table = this._element.getElement('.w_divtable.last');

		if (_last_table) {
			_last_table.removeClass('last');
		}

		_last_table = this._element.getElement('.w_divtable:last-child');

		if (_last_table) {
			_last_table.addClass('last');
		}

		if (this.scrollable && this.scrolling_times) {
			this.scrollable.setOptions({ times: this.scrolling_times });
			this.scrollable.times = this.scrolling_times;
		}
	},

	resize_scroller: function resize_scroller() {
		this._scroller.setStyle('width', this.scroller_width);
	},

	scroll_to: function scroll_to(action) {
		if (this.scrollable && this.scrolling_times) {
			this.scrollable.setOptions({ times: this.scrolling_times });
			this.scrollable.times = this.scrolling_times;
		}

		if (this.scrolling_times > 0) {
			this._element.getElement('.scroll_right').show();

			if (!this.scrollable) {
				this.scrollable = new Scrollable(this._element, {
					element: this._scroller,
					scroll_px: this.scrolling_width,
					times: this.scrolling_times
				});
			} else {
				if (action == 'add') {
					this.scrollable.scroll_to_first();
				} else {
					//check if scroller is at the end
					if (this.scroller_width + this.scrolling_width == this._scroller.getStyle('left').toInt() * -1 + this.main_width) {
						this.scrollable.scroll_to_last('set');
					}
				}
			}
		} else {
			if (this.scrollable) {
				if (action == 'add') {
					this.scrollable.scroll_to_first();
				} else {
					this.scrollable.scroll_to_first('set');
					this.scrollable.destroy();
					this.scrollable = null;
				}
			}
		}
	} //,

	// bulb_show: function(title, _el){
	//	 var main_title = this._parent.getElement('.main_bld .th .name').get('text');

	//	 this._bulb_content.set('html', 'This is the price difference between <strong>' + main_title + '</strong> and <strong>' + title + '</strong>');

	//	 var _pointer = this._bulb.getElement('.pointer');

	//	 this._bulb.show();

	//	 var v_pos = (this._bulb.getSize().y - _pointer.getSize().y) * -1,
	//			 h_pos = _el.getCoordinates().left - this._parent.getCoordinates().left + (_el.getSize().x - this._bulb.getSize().x);

	//	 this._bulb.setStyles({
	//												 'bottom': v_pos,
	//												 'left': h_pos
	//											 });
	//	 this._bulb.setStyle('visibility', 'visible');

	//	 _el.addClass('mouseover');
	// },

	// bulb_hide: function(){
	//	 this._bulb.hide();
	// }
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
--- 
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.4.1: '*'
...
*/

var Scrollable = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_scrollable',
		scroll_px: 0, //amount of pixels to scroll with one click
		times: 1, //how many times to scroll one direction
		element: null //element to scroll
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._scroller = this.options.element;
		this.clickable = true;

		if (this._scroller) {
			this.tween = new Fx.Morph(this._scroller, {
				duration: 300,
				link: 'ignore',
				onComplete: function () {
					this.clickable = true;
				}.bind(this)
			});

			this.ml = 0; //margin-left;
			this.times_left = this.options.times;
			this.times_right = 0;

			if (this.options.times > 0) {
				this._btn_l = this._element.getElement(".scroll_left");
				this._btn_r = this._element.getElement(".scroll_right");

				if (this._btn_l) {
					this._btn_l.addEvent('click', this.scroll_left.bind(this));
				}

				if (this._btn_r) {
					this._btn_r.setStyle('display', 'block');
					this._btn_r.addClass('visible');
					this._btn_r.addEvent('click', this.scroll_right.bind(this));
				}
			}
		}
	},

	scroll_left: function scroll_left() {
		if (this.times_left < this.options.times && this.clickable == true) {
			this.clickable = false;

			this._btn_r.setStyle('display', 'block');
			this._btn_r.addClass('visible');
			this.ml += this.options.scroll_px;

			this.tween.start({
				'left': this.ml
			});

			this.times_left++;
			this.times_right--;

			if (this.times_left == this.options.times) {
				this._btn_l.setStyle('display', 'none');
				this._btn_l.removeClass('visible');
			}
		}
	},

	scroll_right: function scroll_right() {
		if (this.times_right < this.options.times && this.clickable == true) {
			this.clickable = false;

			this._btn_l.setStyle('display', 'block');
			this._btn_l.addClass('visible');
			this.ml -= this.options.scroll_px;

			this.tween.start({
				'left': this.ml
			});

			this.times_right++;
			this.times_left--;

			if (this.times_right == this.options.times) {
				this._btn_r.setStyle('display', 'none');
				this._btn_r.removeClass('visible');
			}
		}
	},

	scroll_to_first: function scroll_to_first(action) {
		if (this.options.times) this.times_left = this.options.times;

		this.times_right = 0;
		this.ml = 0;

		this._btn_l.setStyle('display', 'none');
		this._btn_l.removeClass('visible');

		if (this.options.times > 0) {
			this._btn_r.setStyle('display', 'block');
			this._btn_r.addClass('visible');
		} else {
			this._btn_r.setStyle('display', 'none');
			this._btn_r.removeClass('visible');
		}

		if (action != 'set') {
			this.tween.start({
				'left': 0
			});
		} else {
			this.tween.set({
				'left': 0
			});
		}
	},

	scroll_to_last: function scroll_to_last(action) {
		if (this.options.times) {
			this.times_right = this.options.times;
		}

		this.times_left = 0;

		this.ml = this.options.times * this.options.scroll_px * -1;

		this._btn_r.setStyle('display', 'none');
		this._btn_r.removeClass('visible');

		if (this.options.times > 0) {
			this._btn_l.setStyle('display', 'block');
			this._btn_l.addClass('visible');
		} else {
			this._btn_l.setStyle('display', 'none');
			this._btn_l.removeClass('visible');
		}

		if (action != 'set') {
			this.tween.start({
				'left': this.ml
			});
		} else {
			this.tween.set({
				'left': this.ml
			});
		}
	},

	destroy: function destroy() {
		this._btn_l.hide();
		this._btn_r.hide();
		this._btn_l.removeEvents();
		this._btn_r.removeEvents();
		this.tween = null;
		this._scroller = null;
		this._element = null;
	}
});
'use strict';

Page.Bsc = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
		this.get_stalker_info();
		this.fill_nav_title();

		// this.set_sales_data();
		// this.set_available_apts();
		// this.set_similar_buildings();
		// this.set_floorplans();

		//this.add_alert_link();
		this.add_save_link();
		this.add_share_link();

		this.set_all_units();
		this.set_sell();
		this.set_contact();
		this.set_off_market_deals();

		var _scrollable = document.getElement('.comparison_table .w_scrollable'),
		    comparison_table,
		    _comparison = document.getElement('.pricing_comparison');

		if (_comparison) _comparison.addClass('all');;

		if (_scrollable) {
			var height = _scrollable.getParent().getComputedSize().height;
			_scrollable.setStyle('height', height);

			comparison_table = new ComparisonTable(_scrollable);
		}

		var _search = document.id('building-search');
		if (_search) {
			var limousine = new LimousineExt(_search, {
				min_chars: 3,
				type_ahead: false,
				submit_onenter: false,
				cache: true,
				textfield_selector: 'input#buildingquery',
				custom_action: true
			});

			if (comparison_table) {
				var _main_bld = document.getElement('.comparison_table .main_bld'),
				    type = '';

				if (_main_bld) var type = _main_bld.getProperty('data-current-type');

				limousine.addEvent('runCustomAction', function (a) {
					comparison_table.rpc_request(a + '&b=' + type);

					limousine._field.set('value', '');
				});
				limousine._element.addEvent('click', function () {
					comparison_table.hide_message();
				});
			}
		}

		var _av_on = document.getElement('li.average_on'),
		    _me_on = document.getElement('li.median_on'),
		    _av_act_on = document.getElement('li.average_actual_on'),
		    _me_act_on = document.getElement('li.median_actual_on');

		if (_av_on) {
			_av_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_comparison) {
					_comparison.removeClass('median_act');
					_comparison.removeClass('average_act');
					_comparison.removeClass('median');
					_comparison.addClass('average');
				}
			});
		}

		if (_me_on) {
			_me_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_comparison) {
					_comparison.removeClass('median_act');
					_comparison.removeClass('average_act');
					_comparison.addClass('median');
					_comparison.removeClass('average');
				}
			});
		}

		if (_av_act_on) {
			_av_act_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_comparison) {
					_comparison.removeClass('median_act');
					_comparison.addClass('average_act');
					_comparison.removeClass('median');
					_comparison.removeClass('average');
				}
			});
		}

		if (_me_act_on) {
			_me_act_on.addEvent('click', function (e) {
				e.preventDefault();

				if (_comparison) {
					_comparison.addClass('median_act');
					_comparison.removeClass('average_act');
					_comparison.removeClass('median');
					_comparison.removeClass('average');
				}
			});
		}

		var _select = document.id('rooms_filter');

		if (_select) {
			_select.addEvent('change', function () {
				var _opt = _select.getElement(':selected'),
				    cls = _opt.get('class');

				_comparison.removeClass(this.old_class || 'all');
				_comparison.addClass(cls);

				this.old_class = cls;
			}.bind(this));
		}

		this.bottom_bar();
		//this.add_alert_link();
		this.show_top_nav_contact();
		this.building_stalker_data();
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		var apts_sale = document.getElement('input[name="apts_sale"]').value;
		var apts_rent = document.getElement('input[name="apts_rent"]').value;
		var apts_num = apts_sale + apts_rent;
	},

	show_top_nav_contact: function show_top_nav_contact() {
		var buttonContact = document.getElement('[data-popup-name="contact-popup"');
		var buttonContactTopNav = document.getElement('.button-contact-top');
		if (buttonContact && buttonContactTopNav) {
			buttonContactTopNav.removeClass('none');
		}
	},

	bottom_bar: function bottom_bar() {
		var triggerElement = document.getElement('.content');
		Core.bottom_bar(triggerElement, 150);
	},

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},

	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.alert-button-container .building-alert2');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			var clonedAlertButton = _alertButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedAlertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.alert-button-container .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			var clonedShareButton = _shareButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedShareButton);
		}
	},

	get_stalker_info: function get_stalker_info() {
		var _info = document.getElement('.stalker_info');

		this.apt_sale = _info.getElement('input[name=apts_sale]').get("value");
		this.apt_rent = _info.getElement('input[name=apts_rent]').get("value");
		this.build_name = _info.getElement('input[name=build_name]').get("value");
		this.build_address = _info.getElement('input[name=build_address]').get("value");
		this.build_type = _info.getElement('input[name=build_type]').get("value").capitalize();
		this.build_predev_concept = _info.getElement('input[name=build_predev_concept]').get("value");
		this.map_link = _info.getElement('input[name=map_link]').get("value");
		this.map_name = _info.getElement('input[name=map_name]').get("value");
		this.apt_sale_url = _info.getElement('input[name=apts_sale_url]').get("value");
		this.all_units_url = _info.getElement('input[name=all_units_url]').get("value");
		this.similar_buildings_url = _info.getElement('input[name=similar_buildings_url]').get("value");
		this.sales_history_url = _info.getElement('input[name=sales_history_url]').get("value");
		this.is_sales_history = _info.getElement('input[name=is_sales_history]').get("value");
		this.floorplans_url = _info.getElement('input[name=floorplans_url]') ? _info.getElement('input[name=floorplans_url]').get("value") : '';
		this.sell_url = _info.getElement('input[name=sell_url]') ? _info.getElement('input[name=sell_url]').get("value") : '';
		this.building_total_units = _info.getElement('input[name=building_total_units]') ? _info.getElement('input[name=building_total_units]').get("value") : '0';
	},

	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		var _stalker_info = _stalker_title.getElement('._info');
		var _stalker_build_type = _stalker_title.getElement('._type');
		// var _stalker_map_link = _stalker_title.getElement('._map');

		// var _stalker_build_name = _stalker_title.getElement('._name');
		// check the building name
		// if (this.build_name === ''){
		// 	this.build_name = this.build_address;
		// 	_stalker_build_name.set('text', this.build_name);
		// } else {
		// 	// check the address
		// 	if (this.build_address === '') {
		// 		_stalker_build_name.set('text', this.build_name);
		// 	} else {
		// 		_stalker_build_name.set('text', this.build_name + ', ' + this.build_address);
		// 	}
		// }

		var buildingTypeAndHood = void 0;
		if (this.build_type != '') {
			buildingTypeAndHood = this.build_type;
		}
		if (this.map_name != '') {
			if (this.build_type != '') {
				buildingTypeAndHood += ' in ';
			}
			buildingTypeAndHood += this.map_name;
		}
		_stalker_build_type.set('text', buildingTypeAndHood);
	},

	set_off_market_deals: function set_off_market_deals() {
		var _off_market_deals = document.getElement('.w_stalker ._info .button-off-market-deals');

		if (_off_market_deals) {
			if (this.build_predev_concept == "0" && (this.build_type === 'Condo' || this.build_type === 'Co-Op' || this.build_type === 'Condop')) {
				// nothing to do
			} else {
				_off_market_deals.getParent().dispose();
			}
		}
	},

	set_available_apts: function set_available_apts() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _aval_apts = document.getElement('.w_stalker ._info ._aval_apts');

		if (apts > 0 && _aval_apts && _aval_apts.getElement('._value')) {
			_aval_apts.getElement('._value').set('text', apts);
			_aval_apts.getElement('._text').set('text', 'Available Apt' + (apts > 1 ? 's' : ''));
			_aval_apts.set('href', this.apt_sale_url);
		} else if (_aval_apts) {
			_aval_apts.getParent().dispose();
		}
	},

	set_sales_data: function set_sales_data() {
		var _sales_history = document.getElement('.w_stalker ._info ._sales_history');

		if (_sales_history && this.is_sales_history === '1') {
			_sales_history.set('href', this.sales_history_url);
		} else if (_sales_history) {
			_sales_history.getParent().dispose();
		}
	},

	set_similar_buildings: function set_similar_buildings() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _similar_buildings = document.getElement('.w_stalker ._info ._similar_buildings');

		if (_similar_buildings) {
			_similar_buildings.set('href', this.similar_buildings_url);
		} else if (_similar_buildings) {
			_similar_buildings.getParent().dispose();
		}
	},

	set_all_units: function set_all_units() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _all_units = document.getElement('.w_stalker ._info ._all_units');

		if (_all_units && this.all_units_url && this.build_predev_concept == "0") {
			_all_units.set('href', this.all_units_url);
		} else if (_all_units) {
			_all_units.getParent().dispose();
		}
	},

	// set_floorplans: function() {
	// 	var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
	// 	var _floorplans = document.getElement('.w_stalker ._info ._floorplans');

	// 	if (_floorplans && this.floorplans_url) {
	// 		_floorplans.set('href', this.floorplans_url);
	// 	} else {
	// 		_floorplans.getParent().dispose();
	// 	}
	// }, 

	set_sell: function set_sell() {
		var _sell = document.getElement('.w_stalker ._info ._sell');

		if (_sell) {
			if (_sell && this.sell_url && this.build_type !== 'No Fee Rental' && this.build_type !== 'Townhouse') {
				_sell.set('href', this.sell_url);
				Core.setBuildingSellData(_sell, this.building_total_units);
			} else {
				_sell.getParent().dispose();
			}
		}
	},

	set_contact: function set_contact() {
		var _contact = document.getElement('.w_stalker ._info .button-book-tour');

		if (_contact && this.build_type === 'No Fee Rental') {
			_contact.set('text', 'Contact');
		}
	}
});
//# sourceMappingURL=bsc.js.map
